module.exports = __webpack_public_path__ + "fonts/Lexend-600-latin18.53db120.woff2";